const layoutCandidates = {
  '-': 'ー − ‐ — ―',
  '.': '・ ． 。',
  ',': '、 ，',
  '+': '＋',
  '/': '／',
  '%': '％',
  ':': '：',
  ';': '；',
  '?': '？',
  '!': '！',
  '~': '～',
  '(': '（',
  ')': '）',
  '[': '［',
  ']': '］',
  '{': '｛',
  '}': '｝',
  '"': '「 」 “ ”',
  '\'': '‘ ’',
  '^^': '^_^ (^^) ^_^ ^^ ^_^ \u02C6\u02C6 (^^) (^_^) ^',
};

export default layoutCandidates;
